import Immutable from "immutable";

export default {
    SET_GLOBAL_PROPERTY: (state, action) => {
        let { name, value = "" } = action.payload || {};
        if (name) {
            return state.set(name, Immutable.fromJS(value));
        }
        return state;
    },
    UNSET_GLOBAL_PROPERTY: (state, action) => {
        let { name } = action.payload || {};
        if (name) {
            return state.delete(name);
        }
        return state;
    },
    SET_GLOBAL_CONFIG: (state, action) => {
        let newState = action.payload || {};
        return state.set("globalConfig", newState);
    },
    SAVE_MIXIN_TO_CACHE: (state, action) => {
        return state.setIn(["mixin-cache", action.mixinId], Immutable.fromJS(action.payload));
    },
    SET_ACTIVE_FLOW: (state, action) => {
        let isBlocking = action.payload.isBlocking || false;
        let saveFlowBeforeExit = action.payload.saveFlowBeforeExit || false;
        let pathToFlowEntity = action.payload.widget || "unknown";

        if (isBlocking || saveFlowBeforeExit) {
            return state.merge({
                isBlocking: isBlocking,
                saveFlowBeforeExit: saveFlowBeforeExit,
                activeFlow: pathToFlowEntity
            });
        } else {
            return state;
        }
    },
    RESET_ACTIVE_FLOW: (state) => {
        return state.merge({ isBlocking: false, saveFlowBeforeExit: false, activeFlow: false });
    },
    // SET_ACTIVE_FLOW_TARGET: (state, action) => {
    //     let activeFlowTarget = action.payload.activeFlowTarget || false;
    //     return state.merge({
    //         activeFlowTarget: activeFlowTarget
    //     });
    // },
    SET_FLOW_CONTEXT: (state, action) => {
        let flowContext = action.payload.flowContext || null;
        if (flowContext && state.get("flowContext")) {
            let currentState = state.get("flowContext");
            Object.assign(currentState, flowContext);

            return state.set("flowContext", currentState);
        }
        return state.set("flowContext", flowContext);
    },
    // RESET_ACTIVE_FLOW_TARGET: state => {
    //     return state.merge({ activeFlowTarget: false });
    // },
    SET_FLOW_INPROGRESS: (state) => {
        return state.set("isLoading", true);
    },
    TRIGGER_GLOBAL_LOADING: (state) => {
        if (state.get("applicationLoading")) {
            return state;
        }

        let globalLoadingCounter = state.get("globalLoading");

        globalLoadingCounter = globalLoadingCounter || 0;

        return state.set("globalLoading", globalLoadingCounter + 1);
    },
    DISMISS_GLOBAL_LOADING: (state) => {
        if (state.get("applicationLoading")) {
            return state;
        }
        let globalLoadingCounter = state.get("globalLoading");
        //avoid case when we dismiss loading in the final actions after confirm message reject
        if (globalLoadingCounter > 0) {
            globalLoadingCounter = globalLoadingCounter - 1;
        }
        return state.set("globalLoading", globalLoadingCounter);
    },
    TRIGGER_APPLICATION_LOADING: (state) => {
        return state.set("applicationLoading", true);
    },
    DISMISS_APPLICATION_LOADING: (state) => {
        return state.set("applicationLoading", false);
    },
    TRIGGER_MAIN_AREA_LOADING: (state) => {
        if (state.get("applicationLoading") || state.get("globalLoading")) {
            return state;
        }
        let mainAreaLoadingState = state.get("mainAreaLoadingState");

        mainAreaLoadingState = mainAreaLoadingState || 0;

        return state.set("mainAreaLoadingState", mainAreaLoadingState + 1);
    },
    DISMISS_MAIN_AREA_LOADING: (state) => {
        let mainAreaLoadingState = state.get("mainAreaLoadingState");
        if (mainAreaLoadingState > 0) {
            mainAreaLoadingState = mainAreaLoadingState - 1;
        }
        return state.set("mainAreaLoadingState", mainAreaLoadingState);
    },
    COMPLETE_FLOW_REQUEST: (state) => {
        return state.set("isLoading", true);
    },
    COMPLETE_FLOW_FAILURE: (state) => {
        return state.set("isLoading", false);
    },
    COMPLETE_FLOW_SUCCESS: (state) => {
        return state.set("isLoading", false);
    },
    SET_GLOBAL_THEME: (state, action) => {
        return state.set("theme", action.payload.theme);
    },
    SET_LANGUAGE: (state, action) => {
        return state.set("locale", action.payload.locale);
    },
    SET_APPLICATION_UPDATE_MODE: (state, action) => {
        return state.set("applicationUpdateMode", action.payload.updateMode);
    },
    SET_APPLICATION_BOOT: (state, action) => {
        return state.set("applicationBoot", action.payload);
    },
    SET_MODAL: (state, action) => {
        return state.set("modal", action.payload.modal);
    },
    CLEAR_MODAL: (state) => {
        return state.delete("modal");
    }
};
